import { axios } from "../Support/axios";

export class Documentation {

    constructor(data) {
        this.content = null;
        this.error = false;
    }

    loadDocumentation(page) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/docs' + page)
                .then(response => {
                    self.content = response.data;

                    resolve(response);
                })
                .catch(error => {
                    this.error = error.response;

                    reject(error);
                });
        });
    }

}
